const ESTADOS = {
  OK: {
    bg: "rgba(74,222,128,0.15)",
    border: "rgba(74,222,128,0.4)",
    text: "#22c55e",
    icon: "fa-circle-check",
    label: "OK",
  },
  CERCA: {
    bg: "rgba(251,191,36,0.15)",
    border: "rgba(251,191,36,0.4)",
    text: "#fbbf24",
    icon: "fa-triangle-exclamation",
    label: "Cerca del límite",
  },
  EXCEDIDO: {
    bg: "rgba(239,68,68,0.15)",
    border: "rgba(239,68,68,0.4)",
    text: "#f87171",
    icon: "fa-circle-xmark",
    label: "Excedido",
  },
};

export function PresupuestoBadge({ estado }) {
  const s = ESTADOS[estado];
  if (!s) return null;
  return (
    <span style={{
      fontSize: "0.66rem", fontWeight: 700,
      padding: "2px 8px", borderRadius: 20,
      background: s.bg, border: `1px solid ${s.border}`, color: s.text,
      display: "inline-flex", alignItems: "center", gap: 4, whiteSpace: "nowrap",
    }}>
      <i className={`fa-solid ${s.icon}`} style={{ fontSize: "0.58rem" }} />
      {s.label}
    </span>
  );
}
